import { render } from "./AddReport.vue?vue&type=template&id=1fa3b554&scoped=true"
import script from "./AddReport.vue?vue&type=script&lang=js"
export * from "./AddReport.vue?vue&type=script&lang=js"

import "./AddReport.vue?vue&type=style&index=0&id=1fa3b554&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa3b554"]])

export default __exports__